import React, { useState, useEffect } from 'react';

// Status Table Component
const StatusTable = React.memo(({ isLoading, statusData }) => {
  const [isVisible, setIsVisible] = useState(false);
  
  // Control visibility for smooth animation
  useEffect(() => {
    if (!isLoading) {
      // Small delay before showing to ensure smooth transition
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 100);
      return () => clearTimeout(timer);
    } else {
      setIsVisible(false);
    }
  }, [isLoading]);
  
  return (
    <div className="bg-[#121212] rounded-xl shadow-lg p-4 border border-white/20 mb-6 w-full transform transition-all duration-300 hover:shadow-white/10">
      <div className="flex justify-between items-center mb-3">
        <h3 className="text-lg font-bold text-white">Status Distribution Details</h3>
        {isLoading && (
          <div className="animate-pulse text-white flex items-center">
            <span className="mr-2">Loading</span>
            <span className="flex space-x-1">
              <span className="h-1.5 w-1.5 bg-white rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></span>
              <span className="h-1.5 w-1.5 bg-white rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></span>
              <span className="h-1.5 w-1.5 bg-white rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></span>
            </span>
          </div>
        )}
      </div>
      
      {isLoading ? (
        <div className="h-48 w-full flex items-center justify-center">
          <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-white border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"></div>
        </div>
      ) : (
        <div 
          className={`transition-all duration-500 ease-in-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}
        >
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-800">
              <thead>
                <tr>
                  <th className="px-4 py-2 text-left text-sm font-medium text-white">Status</th>
                  <th className="px-4 py-2 text-right text-sm font-medium text-white">Count</th>
                  <th className="px-4 py-2 text-right text-sm font-medium text-white">Percentage</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-800">
                {statusData.labels.map((status, index) => (
                  <tr 
                    key={status}
                    className="hover:bg-black/40 transition-colors"
                  >
                    <td className="px-4 py-3 whitespace-nowrap">
                      <div className="flex items-center">
                        <div className="h-3 w-3 rounded-full mr-2" style={{ backgroundColor: statusData.colors[index] }}></div>
                        <span className="text-sm text-gray-200 font-medium">{status}</span>
                      </div>
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-right text-gray-200 font-medium">{statusData.data[index]}</td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-right text-white font-medium">
                      {statusData.data[index] > 0 
                        ? `${((statusData.data[index] / statusData.data.reduce((a, b) => a + b, 0)) * 100).toFixed(1)}%` 
                        : '0%'}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
});

export default StatusTable; 